import React, { useEffect } from 'react'
import { Controller, FormContext, useForm } from 'react-hook-form'
import {
  Box,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
  Typography,
  Paper,
  IconButton,
} from '@material-ui/core'
import { File as FileIcon, Download as DownloadIcon } from 'react-feather'

import { BaseDialog, FileUploadInput, LoadingFeedback } from 'components'
import useFetch from 'hooks/useFetch'
import useStyles from './styles'
import * as service from 'service'

const SupplierQuestionModal = ({
  open,
  onClose,
  question,
  onAnswer,
  questionnaireId,
}) => {
  const classes = useStyles()

  const { response, isLoading } = useFetch(
    service.dponet.supplierQuestionnaires.getAlternatives,
    { questionnaireId, questionId: question?.id },
    [],
    open && !!question?.id,
  )

  const alternatives = response?.data?.alternatives || []
  const answerData = response?.data?.answer

  const formMethods = useForm({
    mode: 'onChange',
    defaultValues: {
      selectedAlternative: '',
      justification: '',
      attachments: null,
    },
  })

  const { control, reset, handleSubmit, watch } = formMethods
  const selectedAlternative = watch('selectedAlternative')

  useEffect(() => {
    if (open) {
      reset({
        selectedAlternative:
          answerData?.questionAlternativeId?.toString() || '',
        justification: answerData?.justification || '',
        attachments: null,
      })
    }
  }, [open, answerData, reset])

  const onSubmit = (data) => {
    onAnswer(
      question.id,
      data.selectedAlternative,
      data.justification,
      data.attachments,
      answerData?.id,
    )
    onClose()
  }

  if (!question) return null

  return (
    <FormContext {...formMethods}>
      <LoadingFeedback open={isLoading} />

      <BaseDialog
        open={open}
        setOpen={onClose}
        title={question.theme || 'Responder questão'}
        dialogSize="md"
        fullWidth
        closeIconButton
        actionButton={handleSubmit(onSubmit)}
        actionButtonText={'Salvar'}
        closeButtonText="Cancelar"
        disableButton={!selectedAlternative || isLoading}
      >
        <Box>
          <Box mb={3}>
            <Typography className={classes.questionTitle}>
              {question.question}
            </Typography>
          </Box>

          <Box mb={3}>
            <Typography className={classes.sectionTitle}>
              Selecione uma resposta
            </Typography>
            <Controller
              control={control}
              name="selectedAlternative"
              as={
                <RadioGroup>
                  {alternatives.map((alt) => (
                    <Box
                      key={alt.id}
                      className={`${classes.alternativeItem} ${
                        selectedAlternative === alt.id?.toString()
                          ? classes.alternativeItemSelected
                          : ''
                      }`}
                    >
                      <FormControlLabel
                        value={alt.id?.toString()}
                        control={<Radio size="small" color="primary" />}
                        label={
                          <Typography className={classes.alternativeText}>
                            {alt.title}
                          </Typography>
                        }
                        className={classes.alternativeLabel}
                      />
                    </Box>
                  ))}
                </RadioGroup>
              }
            />
          </Box>

          <Box mb={3}>
            <Typography className={classes.sectionTitle}>
              Justificativa (opcional)
            </Typography>
            <Controller
              control={control}
              name="justification"
              as={
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  size="small"
                  placeholder="Descreva o motivo..."
                  variant="outlined"
                />
              }
            />
          </Box>

          <Box>
            <Typography className={classes.sectionTitle}>
              Evidências (opcional)
            </Typography>
            {answerData?.evidences && answerData.evidences.length > 0 && (
              <Box mb={2}>
                <Typography variant="body2" color="textSecondary">
                  Evidências existentes:
                </Typography>
                {answerData.evidences.map((evidence, index) => (
                  <Paper
                    key={evidence.id}
                    variant="outlined"
                    style={{
                      padding: 8,
                      marginTop: 4,
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <FileIcon size={16} style={{ marginRight: 8 }} />
                    <Typography variant="body2" style={{ flex: 1 }}>
                      {evidence.name}
                    </Typography>
                    <IconButton
                      size="small"
                      onClick={() => window.open(evidence.url, '_blank')}
                    >
                      <DownloadIcon size={16} />
                    </IconButton>
                  </Paper>
                ))}
              </Box>
            )}
            <FileUploadInput
              controlName="attachments"
              title="Anexar novos arquivos"
              multiple
              controllerBar
            />
          </Box>
        </Box>
      </BaseDialog>
    </FormContext>
  )
}

export default SupplierQuestionModal
